/**
 * LIFF Provider Wrapper
 * 提供 LIFF 配置給應用程式
 */

import { createContext, useContext, type ReactNode } from 'react';
import type { LiffConfig } from '@misterlex223/cloudflare-line-liff-sdk/react';

interface LiffContextValue {
  config: LiffConfig;
}

const LiffContext = createContext<LiffContextValue | undefined>(undefined);

export const useLiffConfig = () => {
  const context = useContext(LiffContext);
  if (!context) {
    throw new Error('useLiffConfig must be used within a LiffProvider');
  }
  return context.config;
};

interface Props {
  children: ReactNode;
}

export const LiffProvider: React.FC<Props> = ({ children }) => {
  const config: LiffConfig = {
    // appId 是用於識別應用程式的 ID（對應後端的 LINE_SERVICE_APP_ID）
    // 開發環境: bonbalayelo-platform-preview
    // 生產環境: bonbalayelo-platform
    appId: import.meta.env.VITE_LINE_AUTH_APP_ID || 'belle-selection-preview',
    // liffId 是 LINE LIFF 應用的 ID (從後端環境變數 LINE_LIFF_ID 獲取)
    liffId: import.meta.env.VITE_LINE_LIFF_ID || '2006419578-SNjADskE',
    serviceUrl: import.meta.env.VITE_LINE_SERVICE_URL || 'https://line-liff-service.ambmh.app',
  };

  return (
    <LiffContext.Provider value={{ config }}>
      {children}
    </LiffContext.Provider>
  );
};
